import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const ANALYTICS_API_REDUCER_KEY = "analyticsApi";

export const analyticsApi = createApi({
  reducerPath: ANALYTICS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["analytics"],
  endpoints: (builder) => ({
    getOrgHierarchy: builder.query({
      query: ({ year, base_metric, month }) => {
        if (!year) {
          return;
        }
        let queryParams = [`year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }

        const url = `/emissions/charts/taxonomies?${queryParams.join("&")}`;
        return {
          url: url,
          // url: `/emissions/charts/taxonomies?year=${year}&month=${
          //   month || ""
          // }&base_matric=${base_metric || ""}`,
        };
      },
      providesTags: ["analytics"],
    }),
    getAnalyticsDashboard: builder.query({
      query: ({ year, node, base_metric }) => {
        if (!year || !node) {
          return;
        }
        return {
          url: `/emissions/dashboard/?taxonomy=${node}&year=${year}`,
        };
      },
      providesTags: ["analytics"],
    }),
    getNodeSpendGroupEmission: builder.query({
      query: ({ node, year, base_metric, month }) => {
        if (!year || !node) {
          return;
        }
        let queryParams = [`taxonomy=${node}&year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        const url = `/emissions/charts/sector-alias?${queryParams.join(
          "&"
        )}&limit=100`;
        return {
          url: url,
          // url: `/emissions/charts/sector-alias?taxonomy=${node}&year=${year}&month=${
          //   month || ""
          // }&base_matric=${base_metric || ""}&limit=100`,
        };
      },
      providesTags: ["analytics"],
    }),

    getCategoryEmissions: builder.query({
      query: ({ year, node, month, base_metric }) => {
        if (!node || !year) {
          return;
        }
        let queryParams = [`taxonomy=${node}&year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        const url = `/emissions/charts/emission-categories?${queryParams.join(
          "&"
        )}`;
        return {
          url: url,
          // url: `/emissions/charts/emission-categories?year=${year}&taxonomy=${node}`,
        };
      },
      providesTags: ["analytics"],
    }),
    getEmissionIntensity: builder.query({
      query: ({ year, node, month, base_metric }) => {
        if (!node || !year) {
          return;
        }
        let queryParams = [`taxonomy=${node}&year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        const url = `/emissions/charts/periods/months?${queryParams.join("&")}`;
        return {
          url: url,
          // url: `/emissions/charts/emission-categories?year=${year}&taxonomy=${node}`,
        };
      },
      providesTags: ["analytics"],
    }),

    getScopeEmissions: builder.query({
      query: ({ year, node, month, base_metric, start_date, end_date }) => {
        let queryParams = [`taxonomy=${node}`];
        if (year) {
          queryParams.push(`year=${year}`);
        }
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_metric=${base_metric}`);
        }
        if (start_date && end_date) {
          queryParams.push(`start_date=${start_date}`);
          queryParams.push(`end_date=${end_date}`);
        }
        const url = `/emissions/charts/scopes?${queryParams.join("&")}`;
        return { url };
      },
      providesTags: ["analytics"],
    }),

    getbasematricEmissions: builder.query({
      query: ({ year, node, month, base_metric, start_date, end_date }) => {
        let queryParams = [`taxonomy=${node}`];
        if (year) {
          queryParams.push(`year=${year}`);
        }
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        if (start_date && end_date) {
          queryParams.push(`start_date=${start_date}`);
          queryParams.push(`end_date=${end_date}`);
        }
        const url = `/emissions/charts/scopes?${queryParams.join("&")}`;
        return { url };
      },
      providesTags: ["analytics"],
    }),

    getCategoriesFilterOption: builder.query({
      query: ({ year, node, month, base_metric }) => {
        if (!node || !year) {
          return;
        }
        let queryParams = [`taxonomy=${node}&year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        return {
          url: `/emissions/charts/emission-categories?${queryParams.join("&")}`,
        };
      },
      providesTags: ["analytics"],
    }),

    getCategoriesActivities: builder.query({
      query: ({
        year,
        node,
        category,
        page,
        month,
        base_metric,
        start_date,
        end_date,
      }) => {
        let queryParams = [
          `page=${page}&taxonomy=${node}&category=${category}`,
        ];
        if (year) {
          queryParams.push(`year=${year}`);
        }

        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_metric=${base_metric}`);
        }
        if (start_date) {
          queryParams.push(`start_date=${start_date}`);
        }
        if (end_date) {
          queryParams.push(`end_date=${end_date}`);
        }

        return {
          url: `/emissions/charts/emission-activities?${queryParams.join(
            "&"
          )}&limit=50`,
        };
      },
      providesTags: ["analytics"],
    }),
    getAllCategoriesActivities: builder.query({
      query: ({
        year,
        node,
        category,
        page,
        month,
        base_metric,
        start_date,
        end_date,
      }) => {
        let queryParams = [`taxonomy=${node}`];
        if (category) {
          queryParams.push(`category=${category}`);
        }
        if (page) {
          queryParams.push(`page=${page}`);
        }
        if (year) {
          queryParams.push(`year=${year}`);
        }

        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_metric=${base_metric}`);
        }
        if (start_date) {
          queryParams.push(`start_date=${start_date}`);
        }
        if (end_date) {
          queryParams.push(`end_date=${end_date}`);
        }

        return {
          url: `/emissions/charts/emission-activities?${queryParams.join(
            "&"
          )}&limit=50`,
        };
      },
      providesTags: ["analytics"],
    }),

    getSpendGroupWiseActivities: builder.query({
      query: ({ node, year, page, month, base_metric }) => {
        if (!node || !year) {
          return;
        }
        let queryParams = [`taxonomy=${node}&year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        return {
          url: `/emissions/charts/sector-alias?page=${
            page || 1
          }&${queryParams.join("&")}&limit=50`,
        };
      },
      providesTags: ["analytics"],
    }),
    getSupplierActivities: builder.query({
      query: ({ id, node, year, month, base_metric }) => {
        if (!node || !year || !id) {
          return;
        }
        let queryParams = [`taxonomy=${node}&year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        const url = `/emissions/charts/suppliers/${id}/activities?${queryParams.join(
          "&"
        )}&limit=100`;
        return {
          url: url,
        };
      },
      providesTags: ["analytics"],
    }),
    getSuppliers: builder.query({
      query: ({ node, year, month, base_metric }) => {
        if (!node || !year) {
          return;
        }
        let queryParams = [`taxonomy=${node}&year=${year}`];
        if (month) {
          queryParams.push(`month=${month}`);
        }
        if (base_metric) {
          queryParams.push(`base_matric=${base_metric}`);
        }
        const url = `/emissions/charts/suppliers?${queryParams.join(
          "&"
        )}&limit=300`;
        return {
          url: url,
          // url: `/emissions/charts/suppliers?taxonomy=${node}&year=${year}&limit=300`,
        };
      },
      providesTags: ["analytics"],
    }),
    getUploadedYears: builder.query({
      query: ({ page }) => {
        return {
          url: `/emissions/emission-input-groups/?page=${page || 1}&limit=100`,
        };
      },
      providesTags: ["analytics"],
    }),
    getUncertainty: builder.query({
      query: ({ taxonomyitems, start_date, end_date }) => {
        return {
          url: `uncertainity_analysis/taxonomyitems_analysis/${taxonomyitems}/`,
          params: {
            start_date,
            end_date,
          },
        };
      },
      providesTags: ["analytics"],
    }),
  }),
});

export const {
  useGetOrgHierarchyQuery,
  useGetAnalyticsDashboardQuery,
  useGetNodeSpendGroupEmissionQuery,
  useGetCategoriesFilterOptionQuery,
  useGetCategoriesActivitiesQuery,
  useGetAllCategoriesActivitiesQuery,
  useGetSpendGroupWiseActivitiesQuery,
  useGetSuppliersQuery,
  useGetSupplierActivitiesQuery,
  useLazyGetSupplierActivitiesQuery,
  useGetUploadedYearsQuery,
  useGetUncertaintyQuery,
  useGetCategoryEmissionsQuery,
  useLazyGetScopeEmissionsQuery,
  useGetScopeEmissionsQuery,
  useGetbasematricEmissionsQuery,
  useGetEmissionIntensityQuery,
} = analyticsApi;
